import React, { useState, useEffect } from 'react'
import { Table, Button } from 'antd';
import axios from 'axios';
import { Excel } from "antd-table-saveas-excel";
import _ from "lodash";
import { useTranslation } from 'react-i18next';

const TableComponent = ({ modifiedData, setModifiedData, api, filterText }) => {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false)
    const [responseData, setResponseData] = useState([])
    const [sortedInfo, setSortedInfo] = useState({});
    const [filteredInfo, setFilteredInfo] = useState({});
    const [currentTable, setCurrentTable] = useState([])
    const [lastUpdated, setLastUpdated] = useState(null);

    const getData = async () => {
        setLoading(true)
        await axios.get(api)
            .then(res => {
                if (res.data?.length > 0 && res.data[0]?.created) {
                    setLastUpdated(res.data[0].created);
                }
                if (filterText) {
                    let newArray = [];
                    // Makine adini bosluga duyarsiz karsilastir ("C120" ile "C 120" eslessin).
                    const normMachine = (s) => String(s == null ? '' : s).replace(/\s+/g, '').toLowerCase();
                    newArray = res.data.filter(item => normMachine(item.machine) === normMachine(filterText))
                    setResponseData(newArray)
                } else {
                    setResponseData(res.data)
                }

            })
            .catch(err => console.log(err))
            .finally(() => setLoading(false))
    }

    useEffect(() => {
        getData()
    }, [])

    const handleChange = (pagination, filters, sorter, currentTable) => {
        // console.log('Various parameters', pagination, filters, sorter);
        setFilteredInfo(filters);
        setSortedInfo(sorter);
        setCurrentTable(currentTable?.currentDataSource)

    };
    const clearFilters = () => {
        setFilteredInfo({});
        setCurrentTable([])

    };

    const clearAll = () => {
        setFilteredInfo({});
        setSortedInfo({});
        setCurrentTable([])

    };

    const filterData = data => formatter => currentTable.length > 0 ? currentTable.map(item => ({
        text: formatter(item),
        value: formatter(item)
    })) : modifiedData.map(item => ({
        text: formatter(item),
        value: formatter(item)
    }));
    // const panelData =(panelGroup) =>{
    //     return (<div>
    //         {JSON.stringify(panelGroup).substring(1,JSON.stringify(panelGroup).length-1)}
    //     </div>)
    // }


    useEffect(() => {
        const dataList = responseData?.map((item, index) => ({
            key: index + 1,
            date: item.date,
            finishTime: item.finishTime,
            machine: item.machine,
            startTime: item.startTime,
            parcatanimi: item?.parcatanimi,
            target: item?.target,
            panelcode: item?.panelcode,
            vip_target_field: item?.vip_target_field,

        }));

        setModifiedData([...dataList]);
    }, [responseData]);

    const columns = [
        {
            title: t('table.date'),
            dataIndex: 'date',
            key: 'date',
            filters: _.uniqWith(filterData(modifiedData)(i => i.date), _.isEqual),
            filteredValue: filteredInfo.date || null,
            onFilter: (value, record) => record.date === value,
            sorter: (a, b) => a.date.localeCompare(b.date),
            sortOrder: sortedInfo.columnKey === 'date' ? sortedInfo.order : null,
            width: 150,
        },
        {
            title: t('table.startTime'),
            dataIndex: 'startTime',
            key: 'startTime',
            filters: _.uniqWith(filterData(modifiedData)(i => i.startTime), _.isEqual),
            filteredValue: filteredInfo.startTime || null,
            onFilter: (value, record) => record.startTime === value,
            sorter: (a, b) => a.startTime.localeCompare(b.startTime),
            sortOrder: sortedInfo.columnKey === 'startTime' ? sortedInfo.order : null,
            width: 150,
        },
        {
            title: t('table.finishTime'),
            dataIndex: 'finishTime',
            key: 'finishTime',
            filters: _.uniqWith(filterData(modifiedData)(i => i.finishTime), _.isEqual),
            filteredValue: filteredInfo.finishTime || null,
            onFilter: (value, record) => record.finishTime === value,
            sorter: (a, b) => a.finishTime.localeCompare(b.finishTime),
            sortOrder: sortedInfo.columnKey === 'finishTime' ? sortedInfo.order : null,
            width: 150,
        },
        {
            title: t('table.machine'),
            dataIndex: 'machine',
            key: 'machine',
            width: 150,
        },
        {
            title: t('table.partDefinition'),
            dataIndex: 'parcatanimi',
            key: 'parcatanimi',
            filters: _.uniqWith(filterData(modifiedData)(i => i.parcatanimi), _.isEqual),
            filteredValue: filteredInfo.parcatanimi || null,
            onFilter: (value, record) => record.parcatanimi === value,
            width: 150,
        },
        {
            title: t('table.quantity'),
            dataIndex: 'target',
            key: 'target',
            filters: _.uniqWith(filterData(modifiedData)(i => i.target), _.isEqual),
            filteredValue: filteredInfo.target || null,
            onFilter: (value, record) => record.target === value,
            sorter: (a, b) => a.target.localeCompare(b.target),
            width: 150,
        },
        {
            title: t('table.panelCode'),
            dataIndex: 'panelcode',
            key: 'panelcode',
            filters: _.uniqWith(filterData(modifiedData)(i => i.panelcode), _.isEqual),
            filteredValue: filteredInfo.panelcode || null,
            onFilter: (value, record) => record.panelcode === value,
            width: 150,
        },
        {
            title: t('table.vipQuantity'),
            dataIndex: 'vip_target_field',
            key: 'vip_target_field',
            filters: _.uniqWith(filterData(modifiedData)(i => i.vip_target_field), _.isEqual),
            filteredValue: filteredInfo.vip_target_field || null,
            onFilter: (value, record) => record.vip_target_field === value,
            width: 150,
        },
    ];

    const handleClick = () => {
        const excel = new Excel();
        excel
            .addSheet("test")
            .addColumns(columns)
            .addDataSource(modifiedData, {
                str2Percent: true
            })
            .saveAs(`${window.location.pathname.slice(10,)}.xlsx`);
    };

    return (
        <div>
            <div className='flex justify-between items-center mb-2'>
                <div className='flex gap-1'>
                    <Button className='rounded-none	bg-white' onClick={handleClick}>{t('table.export')}</Button>
                    <Button className='rounded-none	bg-white' onClick={clearFilters}>{t('table.clearFilters')}</Button>
                    <Button className='rounded-none	bg-white' onClick={clearAll}>{t('table.clearAll')}</Button>
                </div>
                {lastUpdated && (
                    <div className='font-semibold text-gray-700'>
                        {t('table.lastUpdated')} {(() => {
                            const d = new Date(lastUpdated);
                            if (isNaN(d.getTime())) return lastUpdated;
                            d.setHours(d.getHours());
                            const dd = String(d.getDate()).padStart(2, '0');
                            const mm = String(d.getMonth() + 1).padStart(2, '0');
                            const yyyy = d.getFullYear();
                            const hh = String(d.getHours()).padStart(2, '0');
                            const min = String(d.getMinutes()).padStart(2, '0');
                            const ss = String(d.getSeconds()).padStart(2, '0');
                            return `${yyyy}-${mm}-${dd} ${hh}:${min}:${ss}`;
                        })()}
                    </div>
                )}
            </div>
            <div>
                <Table
                    dataSource={modifiedData}
                    columns={columns}
                    pagination={{
                        pageSize: 6,
                        showSizeChanger: true,
                        showTotal: (total) => `${t('table.total')}: ${total}`,
                        showQuickJumper: true,
                        showSizeChanger: true,
                        pageSizeOptions: ['6', '10', '20', '50'],
                        locale: {
                            items_per_page: t('table.pageSize'),
                            jump_to: t('table.jumpTo'),
                            jump_to_confirm: t('table.confirm'),
                            page: t('table.page'),
                        }
                    }}
                    rowClassName={(record, index) => index % 2 === 0 ? 'table-row-light' : 'table-row-dark'}
                    sticky
                    loading={loading}
                    onChange={handleChange}
                />
            </div>
        </div>
    )
}

export default TableComponent
